import { render, staticRenderFns } from "./ConnectionRequestList.vue?vue&type=template&id=1fac07f5&"
import script from "./ConnectionRequestList.vue?vue&type=script&lang=js&"
export * from "./ConnectionRequestList.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionRequestList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports